import { combineReducers, configureStore } from "@reduxjs/toolkit";

// import { errorsReducer as errors } from './errors';
import { sessionReducer as session } from "./session";
import { terceroReducer as tercero } from "./tercero";
import { tipoventasReducer as tipoventas } from "./tipoventas";
import { tipocomprobantesReducer as tipocomprobantes } from "./tipocomprobante";
import { talonarioReducer as talonario } from "./talonario";
import { comprobanteReducer as comprobante } from "./comprobante";
import { pagoReducer as pago } from "./pago";
import { usuariosReducer as usuarios } from "./usuarios";
import { municipioReducer as municipio } from "./municipio";
import { departamentoReducer as departamento } from "./departamento";
import { actividadEconomicaReducer as actividadEconomica } from "./actividad_economica";

const reducer = combineReducers({
    session,
    tercero,
    tipoventas,
    talonario,
    tipocomprobantes,
    comprobante,
    pago,
    usuarios,
    municipio,
    departamento,
    actividadEconomica,
});

export { sessionActions } from "./session";
export { terceroActions } from "./tercero";
export { tipoventasActions } from "./tipoventas";
export { talonarioActions } from "./talonario";
export { tipocomprobantesActions } from "./tipocomprobante";
export { comprobanteActions } from "./comprobante";
export { pagoActions } from "./pago";
export { usuariosActions } from "./usuarios";
export { municipioActions } from "./municipio";
export { departamentoActions } from "./departamento";
export { actividadEconomicaActions } from "./actividad_economica";

export default configureStore({
    reducer,
});
